import React, { useMemo, useState } from "react";
import "./Home.css";

import { getStoredData } from "../../api/fetchData.jsx";
import RightUpdatesPanel from "../../components/RightUpdatesPanel/RightUpdatesPanel.jsx";

import ProjectSelectionView from "./components/ProjectSelectionView.jsx";
import DashboardView from "./components/DashboardView.jsx";

const Home = () => {
  const adminFunctions = getStoredData()?.[0]?.Functions || [];

  const userDetails = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("userDetails") || "{}");
    } catch {
      return {};
    }
  }, []);

  const assignedProjects = useMemo(() => {
    return Array.isArray(userDetails.project) ? userDetails.project : [];
  }, [userDetails]);

  const [searchTerm, setSearchTerm] = useState("");

  const [selectedProject, setSelectedProject] = useState(
    localStorage.getItem("selectedProject") || "",
  );

  const [viewMode, setViewMode] = useState(
    selectedProject ? "dashboard" : "select",
  );

  const activeProject = useMemo(() => {
    if (!selectedProject) return null;
    return assignedProjects.find((project) => project._id === selectedProject);
  }, [assignedProjects, selectedProject]);

  const filteredProjects = useMemo(() => {
    if (!searchTerm.trim()) return assignedProjects;

    const term = searchTerm.toLowerCase();

    return assignedProjects.filter((project) => {
      const name = project.projectName?.toLowerCase() || "";
      const id = project.projectId?.toLowerCase() || "";
      const company = project.company?.toLowerCase() || "";
      const location = project.siteLocation?.toLowerCase() || "";

      return (
        name.includes(term) ||
        id.includes(term) ||
        company.includes(term) ||
        location.includes(term)
      );
    });
  }, [assignedProjects, searchTerm]);

  const handleProjectSelect = (projectId) => {
    setSelectedProject(projectId);
    localStorage.setItem("selectedProject", projectId || "");
    setViewMode("dashboard");
  };

  const handleBackToProjects = () => {
    setViewMode("select");
  };

  return (
    <div className="admin-dashboard">
      <RightUpdatesPanel className="right-updates" />

      <div className="home-content-container">
        {viewMode === "select" && (
          <ProjectSelectionView
            userDetails={userDetails}
            assignedProjects={assignedProjects}
            filteredProjects={filteredProjects}
            selectedProject={selectedProject}
            searchTerm={searchTerm}
            onSearchChange={setSearchTerm}
            onProjectSelect={handleProjectSelect}
          />
        )}

        {viewMode === "dashboard" && (
          <DashboardView
            functions={adminFunctions}
            selectedProject={selectedProject}
            activeProject={activeProject}
            onBackToProjects={handleBackToProjects}
          />
        )}
      </div>
    </div>
  );
};

export default Home;
